<template>
  <b-container fluid class="p-4 bg-dark">
    <div class="wl-container">
      <div class="btn-group btn-group-toggle">
        <b-img-lazy
          v-bind="mainProps"
          v-for="(src, index) in uris"
          :key="`${src}-${index}`"
          :src="renderUrl(src)"
          :alt="src"
          :class="{ 'background-selection': src === selectedSignature  }"
          v-on:click.native.prevent="setSelectedSignature(src)"
        >
        </b-img-lazy>
      </div>
    </div>
  </b-container>
</template>
<script>
import { mapGetters } from 'vuex'

import IncludeHelperComponent from '../plugins/includeHelperComponent'

export default {
  extends: IncludeHelperComponent,
  props: {
    uris: {
      type: Array,
      required: true,
    },
    mainProps: {
      type: Object,
      default: () => {
        return {
          center: true,
          thumbnail: true,
          fluid: true,
          blank: true,
          blankColor: '#777',
          width: 400,
          height: 200,
          class: 'my-5',
        }
      },
    },
  },
  data() {
    return {
      selectedSignature: null,
    }
  },
  computed: {
    ...mapGetters({
      authToken: 'authToken',
    }),
  },
  methods: {
    setSelectedSignature(src) {
      this.$set(this.$data, 'selectedSignature', src)
      this.$store.dispatch('getSelectResourceSignatureGenerationProcess', src)
    },
  },
}
</script>
<style scoped>
.background-selection {
  background-color: gray;
}
.selection-signature:hover {
  cursor: pointer;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
